import React from "react";
import { TextField, Button, CircularProgress } from "@mui/material";
import { useTranslation } from "@/hooks/useTranslation";

const EmailStep = ({ 
    email, 
    onChange, 
    onSubmit, 
    isEmailValid, 
    isLoading, 
    onKeyPress 
}) => {
    const { t } = useTranslation();
    
    return (
        <>
            <TextField
                fullWidth
                label={t('auth.login.email')}
                variant="outlined"
                value={email}
                onChange={(e) => onChange(e.target.value)}
                onKeyPress={(e) => onKeyPress(e, onSubmit)}
                margin="normal"
                error={!isEmailValid && email.length > 0}
                disabled={isLoading}
            />
            <Button
                fullWidth
                variant="contained"
                onClick={onSubmit}
                disabled={!isEmailValid || isLoading}
                sx={{ mt: 2 }}
            >
                {isLoading ? (
                    <CircularProgress size={24} color="inherit" />
                ) : (
                    t('auth.login.requestCode')
                )}
            </Button>
        </>
    );
};

export default EmailStep;